import styled, { css } from "styled-components";
import generatePicker from "antd/es/date-picker/generatePicker";
import dayjsGenerateConfig from "rc-picker/lib/generate/dayjs";

// antd 4.x DatePicker configured to work with dayjs instead of moment
export const AntdDatePicker = generatePicker(dayjsGenerateConfig);

// Matches the legacy `InputWithLabel` look; pass a `theme` prop to override per form
export const DEFAULT_DATE_PICKER_THEME = {
  height: "48px",
  borderRadius: "5px",
  borderColor: "#dadada",
  padding: "8px",
  fontSize: "14px",
  textColor: "#002244",
  placeholderColor: "#002244",
  focusColor: "#5ddb98",
  filledColor: "#5ddb98",
  keepFilledBorderColor: false,
  errorColor: "#c53030",
  disabledOpacity: 0.7,
  disabledBackground: "#f2f2f2",
};

export const CustomDatePicker = styled(AntdDatePicker)`
  width: 100%;
  height: ${({ $theme }) => $theme.height};
  border-radius: ${({ $theme }) => $theme.borderRadius} !important;
  border: 1px solid ${({ $theme }) => $theme.borderColor} !important;
  padding: ${({ $theme }) => $theme.padding} !important;
  background: transparent;

  @media (max-width: 500px) {
    width: 100%;
  }
  & + div {
    margin-top: 24px;
  }

  .ant-picker-input > input {
    font-size: ${({ $theme }) => $theme.fontSize};
    color: ${({ $theme }) => $theme.textColor};
    font-family: "Open Sans";
    &::placeholder {
      color: ${({ $theme }) => $theme.placeholderColor};
    }
  }

  .ant-picker-suffix,
  .ant-picker-clear {
    color: ${({ $theme }) => $theme.borderColor};
  }

  &.ant-picker-focused {
    border-color: ${({ $theme }) => $theme.focusColor} !important;
    box-shadow: none !important;
  }

  ${(props) =>
    props.$isFocused &&
    css`
      border-color: ${props.$theme.focusColor} !important;
    `}

  ${(props) =>
    props.$isFilled &&
    props.$theme.keepFilledBorderColor &&
    css`
      border-color: ${props.$theme.filledColor} !important;
    `}

  ${(props) =>
    props.$isErrored &&
    css`
      border-color: ${props.$theme.errorColor} !important;
    `}

  ${(props) =>
    props.disabled &&
    css`
      opacity: ${props.$theme.disabledOpacity};
      background-color: ${props.$theme.disabledBackground};
    `}
`;

export const Error = styled.div`
  margin: 5px 0px !important;
  display: flex;
  font-size: 10px;
  align-items: center;
  justify-content: flex-start;
  color: #e00000;
  text-align: left;
  svg {
    margin-right: 4px;
    min-width: 32px;
  }
  span {
    background: #c53030;
    color: #fff;
    &::before {
      border-color: #c53030 transparent;
    }
  }
`;

export const LabelContainer = styled.div`
  margin-right: 8px;
  margin-bottom: 8px;

  ${(props) =>
    props.labelWidth &&
    css`
      width: ${props.labelWidth};
      @media (max-width: 500px) {
        width: auto;
      }
    `}
`;

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 16px;
  ${(props) =>
    props.maxWidth &&
    css`
      max-width: ${props.maxWidth};
    `}
`;

export const Label = styled.span`
  flex: 1;
  margin-right: 8px;
  font-size: 12px;
  font-weight: 600;
  ${(props) =>
    props.labelWidth &&
    css`
      width: ${props.labelWidth};
    `}
  word-wrap: break-word;
  @media (max-width: 500px) {
    width: 100%;
  }

  ${(props) =>
    props.labelOrientation === "vertical" &&
    css`
      margin-bottom: 8px;
    `}
`;

export const Tooltip = styled.div`
  flex: 0.1;
  align-self: center;
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  ${(props) =>
    props.labelOrientation === "horizontal" &&
    css`
      flex-direction: row;
    `}

  ${(props) =>
    props.labelOrientation === "vertical" &&
    css`
      flex-direction: column;
      align-items: unset;
    `}

  
  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const AsteriskText = styled.span`
  color: #c53030;
`;
